import {
  TCardLayoutSlot,
  TCard,
} from '@/console/features/card-layout/card-layout.types';

export const generateGridTemplate = (cards: TCard[]): string => {
  const cardsPerSlot = Object.values(TCardLayoutSlot).reduce(
    (acc, slot) => ({
      ...acc,
      [slot]: cards.filter((card) => card.position.slot === slot),
    }),
    {} as Record<TCardLayoutSlot, TCard[]>,
  );

  const hasRight = cardsPerSlot.RIGHT.length > 0;
  const hasBottom = cardsPerSlot.BOTTOM.length > 0;
  const hasTop = cardsPerSlot.TOP.length > 0;

  // Generate template areas without quotes
  let areas = [];
  if (hasTop) {
    areas.push(hasRight ? 'TOP TOP RIGHT' : 'TOP TOP TOP');
  }
  if (hasBottom) {
    areas.push(hasRight ? 'BOTTOM BOTTOM RIGHT' : 'BOTTOM BOTTOM BOTTOM');
  }

  // If no areas defined (no cards), set a default
  if (areas.length === 0) {
    areas.push('TOP TOP TOP');
  }

  return areas.join('\n');
};
